// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"afafe899","296":"7ae965ef","338":"1de6c90c","386":"b5fa7c74","430":"a6eae8bd","453":"d855a71b","456":"e41e535e","790":"fca6bf0e"}[chunkId] + ".chunk.js";
};